import { Tooltip as MantineTooltip } from '@mantine/core';
import { Box } from '@ui-lib';
import type { ReactNode } from 'react';

import { unresponsiveProperties } from '../../css/atoms/atomicProperties';
import { labelContainer, tooltip } from './Tooltip.css';

type TooltipTone = 'neutral' | 'warning';

interface TooltipProps {
  label: ReactNode;
  open?: boolean;
  tone?: TooltipTone;
  position?: 'top' | 'right' | 'bottom' | 'left';
  disabled?: boolean;
  children?: ReactNode;
  padding?: 'base' | 'compact' | 'none';
}

export const Tooltip = ({
  label,
  open,
  padding = 'base',
  tone = 'neutral',
  position = 'top',
  children,
  disabled = true,
}: TooltipProps) => {
  const wrappedLabel = <Box className={labelContainer}>{label}</Box>;

  return (
    <MantineTooltip
      className={tooltip({
        tone,
        padding,
      })}
      withArrow
      opened={open}
      label={wrappedLabel}
      position={position}
      arrowSize={10}
      disabled={disabled}
      zIndex={unresponsiveProperties.zIndex.tooltip}
    >
      {children}
    </MantineTooltip>
  );
};
